import React from 'react';
import { Center, Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { ChevronRightIcon } from '@fiverr-private/visuals';
import { CategoryIcon } from './CategoryIcon';
import { MenuRow } from './MenuRow';
import { categoryChevron, categoryIcon, categoryRow } from './CategoriesMenuPanel.ve.css';

interface CategoryRowProps {
    id: string;
    label: string;
    webIcon?: string;
    isSelected: boolean;
    onClick: () => void;
}

export const CategoryRow = ({ id, label, webIcon, isSelected, onClick }: CategoryRowProps) => (
    <MenuRow className={categoryRow} data-category-id={id} isSelected={isSelected} onClick={onClick}>
        <Center
            className={categoryIcon}
            width="40px"
            height="40px"
            flexShrink="0"
            borderRadius="lg"
            backgroundColor="grey_200"
            color="grey_1200"
            aria-hidden="true"
        >
            <CategoryIcon webIcon={webIcon} />
        </Center>
        <Text flexGrow="1" overflowWrap="anywhere" color="bodyPrimary">
            {label}
        </Text>
        <Container className={categoryChevron} display="flex" color="grey_900" flexShrink="0" aria-hidden="true">
            <ChevronRightIcon size="sm" color="currentColor" />
        </Container>
    </MenuRow>
);
